import { render, staticRenderFns } from "./HeaderInstitution.vue?vue&type=template&id=445d46a9&scoped=true&"
import script from "./HeaderInstitution.vue?vue&type=script&lang=ts&"
export * from "./HeaderInstitution.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderInstitution.vue?vue&type=style&index=0&id=445d46a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445d46a9",
  null
  
)

export default component.exports